<template>
  <div>
    <a :href="apiUrl" target="blank" class="link" ref="link">Go api document page ..</a>
  </div>
</template>
<script>
export default {
	data(){
		return {
			apiUrl:"https://www.pikakads.com/apiDocument.html"
		}
	},
	mounted(){
		this.$refs.link.click();
	}
}
</script>
<style scoped>
.link{
  font-size: 12px;
}
</style>